// SEO identifies the public marketing site, independently of the hosted app URL.
export const SEO_ORIGIN = new URL(
  process.env.NEXT_PUBLIC_SEO_ORIGIN || 'https://heyform.net'
).origin

export function canonicalUrl(
  path = '/',
  locale = 'en',
  defaultLocale = 'en'
): string {
  let cleanPath = path.split(/[?#]/)[0]
  if (!cleanPath.startsWith('/')) cleanPath = `/${cleanPath}`
  if (locale && locale !== defaultLocale) cleanPath = `/${locale}${cleanPath}`
  cleanPath = cleanPath.replace(/\/+$/, '')
  return `${SEO_ORIGIN}${cleanPath}`
}

export function serializeJsonLd(value: unknown): string {
  // CMS text must never be able to terminate the script element.
  return JSON.stringify(value).replace(/</g, '\\u003c')
}

export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    '@type': 'BreadcrumbList',
    '@id': `${canonicalUrl(items[items.length - 1].path)}#breadcrumb`,
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: canonicalUrl(item.path)
    }))
  }
}
